import { launchDarklyHelper, LD_FEATURE_FLAGS } from '../../services/launchDarkly.service'
import { isEnvDevelop } from '../../utils/node.util'
import { config } from '../../config'

/**
 * A Utility function to get the help link based on the environment and feature flag.
 * @function getHelpLink
 * @returns {string} - Help URL
 */
export const getHelpLink = () => {
    const helpLinks = {
        dev: "https://help.dev.q4inc.com/qphc/desktop",
        prod: "https://help.q4inc.com/qphc/desktop",
    }
    const useNewHelpSiteLink = !!launchDarklyHelper.getLocalFlag(LD_FEATURE_FLAGS.USE_NEW_HELP_SITE_LINK)

    let hostname = ''
    if (typeof window !== 'undefined') {
        hostname = (window && window.location && window.location.hostname) || '';
    }
    const hostnameSegments = hostname.toLowerCase().split('.') || '';

    if (useNewHelpSiteLink) {
        if (hostnameSegments.includes('develop')) {
            return helpLinks.dev;
        } else if (hostnameSegments.includes('staging')) {
            return helpLinks.dev;
        } else if (hostnameSegments.includes('preprod')) {
            return  helpLinks.prod;
        } else if (hostnameSegments.join('.') === 'q4desktop.com' || hostnameSegments.join('.') === 'www.q4desktop.com') {
            return  helpLinks.prod;
        } else {
            return helpLinks.dev;
        }
    }
    return `${config.helpUrl}/index.html`;
}
